import { Collapse, CollapseProps } from 'antd';
import React from 'react'
import OboAccountConfig from '../OboAccountConfig/oboAccountConfig';

const UserConfigContainer = (props:any) => {

    const items: CollapseProps['items'] = [
        {
          key: '1',
          label: 'OBO Account configuration for Sales',
          children: <OboAccountConfig/>,
        },
      ];

  return (
    <div>
    <Collapse accordion items={items} />
    </div>
    
  )
}

export default UserConfigContainer